<div class="{uiClasses} buttons">
  {>slot}
</div>
